import { render } from "./TagsInput.vue?vue&type=template&id=450df34a&ts=true"
import script from "./TagsInput.vue?vue&type=script&lang=ts"
export * from "./TagsInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__